var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.043 14.816a2.323 2.323 0 00-1.729 0L19.58 25.909l11.172 4.466 28.6-11.437-10.308-4.122zm16.563 6.627l-28.6 11.437 11.173 4.466 28.6-11.437-11.173-4.466zm15.104 7.9L50.502 41.426v36.817L80.71 66.159V29.343zM45.855 78.247V41.422L15.647 29.343v36.821l30.208 12.083zm-.265-67.749a6.971 6.971 0 015.177 0l33.131 13.255a2.324 2.324 0 011.46 2.156v40.255a4.647 4.647 0 01-2.924 4.313L49.043 83.833a2.323 2.323 0 01-1.729 0L13.928 70.477A4.647 4.647 0 0111 66.164V25.91a2.324 2.324 0 011.46-2.156l33.13-13.255z",
    fill: "#fff"
  })));
}

export default SvgBox;